/**
 * @flow
 * @relayHash e19edf5178dec7295e94616cede5f2d2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type fantasyLeaderboardSubscriptionVariables = {|
  event_id: string
|};
export type fantasyLeaderboardSubscriptionResponse = {|
  +updateFantasyLeadarboard: ?{|
    +event_id: ?number
  |}
|};
export type fantasyLeaderboardSubscription = {|
  variables: fantasyLeaderboardSubscriptionVariables,
  response: fantasyLeaderboardSubscriptionResponse,
|};
*/


/*
subscription fantasyLeaderboardSubscription(
  $event_id: ID!
) {
  updateFantasyLeadarboard(event_id: $event_id) {
    event_id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "event_id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateFantasyLeadarboard",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "event_id",
        "variableName": "event_id"
      }
    ],
    "concreteType": "updateFantasyLeadarboardType",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "event_id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "fantasyLeaderboardSubscription",
    "type": "Subscriptions",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "fantasyLeaderboardSubscription",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "subscription",
    "name": "fantasyLeaderboardSubscription",
    "id": null,
    "text": "subscription fantasyLeaderboardSubscription(\n  $event_id: ID!\n) {\n  updateFantasyLeadarboard(event_id: $event_id) {\n    event_id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ee823aea3ebacc36894bbafca8eb17a8';
module.exports = node;
